import { ActivatedRouteSnapshot, DetachedRouteHandle, RouteReuseStrategy } from '@angular/router';

export class CustomReuseStrategy implements RouteReuseStrategy {
  routesToCache: string[] = ["itemlist", "search"];
  storedRouteHandles = new Map<string, DetachedRouteHandle>();

  // Decides if the route should be stored
  shouldDetach(route: ActivatedRouteSnapshot): boolean {
    let detach = this.routesToCache.indexOf(route.data["key"]) > -1;
    if (detach)
      console.warn('route.url: ' + route.url + ' is being detached');

    return detach;
  }

  //Store the information for the route we're destructing
  store(route: ActivatedRouteSnapshot, handle: DetachedRouteHandle): void {
    this.storedRouteHandles.set(route.data["key"], handle);
  }

  //Return true if we have a stored route object for the next route
  shouldAttach(route: ActivatedRouteSnapshot): boolean {
    return this.storedRouteHandles.has(route.data["key"]);
  }

  //If we returned true in shouldAttach(), now return the actual route data for restoration
  retrieve(route: ActivatedRouteSnapshot): DetachedRouteHandle {
    return this.storedRouteHandles.get(route.data["key"]);
  }

  //Reuse the route if we're going to and from the same route
  //IMPORTANT!: As of "4.1.2" arguments are swapped per documentation. https://github.com/angular/angular/issues/16192
  shouldReuseRoute(curr: ActivatedRouteSnapshot, future: ActivatedRouteSnapshot): boolean {

    var routeToFlush: ActivatedRouteSnapshot;
    if (curr.routeConfig != null) {
      //let's flush the routes if going to the item list or search (except when coming back from item detail)
      if (curr.data['key'] != 'noflush' && this.routesToCache.indexOf(future.data['key']) > -1) {
        routeToFlush = future;
      }else if (this.routesToCache.indexOf(curr.data['key']) > -1 && future.data['key'] != 'noflush') {
        routeToFlush = curr;
      }
      if (routeToFlush && routeToFlush.data['key'] && this.storedRouteHandles.has(routeToFlush.data['key'])) {
        this.storedRouteHandles.delete(routeToFlush.data['key']);
      }
    }

    return future.routeConfig === curr.routeConfig;
  }
}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/shared/providers/custom-reusestrategy.ts